import React, { useState } from 'react';
import {
  NavLink as NavLink1,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Input,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Modal,
  ModalBody,
} from 'reactstrap';
import classnames from 'classnames';
import SearchSVG from '../../components/svg/search-svg';
import RenderAnswerPreview from '../../components/common/RenderAnswerPreview';
import { getValue } from '../../core/lodash';
import Pagination from 'react-js-pagination';
import { NavLink, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';

interface IQuestionBankHomeProps {
  questionsList: any[];
  totalCount: number;
  onProductPageChangeHandler: (pageNumber: number) => void;
  pageNumber: number;
  limit: number;
  //   specificSurvey: object;
  //   getSpecificSurveyInfo: (id: number) => void;
  //   name: string;
  //   handleChange: (e: any) => void;
  //   handleCreate: () => void;
  //   handleChangeSearch: (e: any) => void;
  //   searchInput: string;
  isLoading: boolean;
}

const QuestionBankHome: React.FunctionComponent<IQuestionBankHomeProps> = (
  props
) => {
  const [activeTab2, setActiveTab2] = useState('1');
  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);
  const toggle2 = (tab) => {
    if (activeTab2 !== tab) setActiveTab2(tab);
  };
  const history = useHistory();

  //   const handlenavigate = () => {
  //     toggleModal();
  //   };
  //   const handleEdit = () => {
  //     Cookies.set('existingSurvey', true);
  //     history.push(
  //       `/create-new-survey-form/${getValue(props, 'specificSurvey.id', '')}`
  //     );
  //   };
  //   const handleChangeSurvey = (id) => {
  //     props.getSpecificSurveyInfo(id);
  //   };
  //console.log(getValue(props, 'questionsList', []));
  return (
    <div className="choose-template-layout">
      <div className="choose-template-list">
        <div className="choose-template-list-top">
          {/* <SearchSVG />
          <Input
            type="text"
            placeholder="Search"
            value={props.searchInput}
            onChange={props.handleChangeSearch}
          /> */}
          Preview Questions
        </div>
        <Nav pills className="menu-ul">
          {/* <li>
            <h6>Customer Satisfaction survey</h6>
          </li> */}
          {/* {getValue(props, 'questionsList', []).map((survey) => {
            return (
              <NavItem>
                <NavLink1
                  className={classnames({
                    active:
                      survey.id === getValue(props, 'specificSurvey.id', ''),
                  })}
                  onClick={() => handleChangeSurvey(survey.id)}
                >
                  {survey.name}
                </NavLink1>
              </NavItem>
            );
          })} */}
        </Nav>
        <Button color="primary">Add Questions</Button>
      </div>
      <div className="choose-template-height">
        <TabContent activeTab={activeTab2}>
          <TabPane tabId="1">
            <div className="page-padding">
              <Row>
                <Col lg={{ size: 10, offset: 1 }}>
                  {getValue(props, 'questionsList.length', []) !== 0 ? (
                    <>
                      <h3 className="text-left">Question bank</h3>
                      <h3 className="text-right">
                        {getValue(props, 'totalCount', '')} Question(s)
                      </h3>
                      <Card>
                        <CardBody>
                          <h3 className="text-center">Sample Questions</h3>
                          <h5 className="text-red mb-0">
                            {' '}
                            {getValue(props, 'specificSurvey.name', '')}
                          </h5>
                          {/* <p>
                          This section contains questions about your personal
                          development
                        </p> */}
                          {!getValue(props, 'isLoading', false)
                            ? getValue(props, 'questionsList', []).map(
                                (question, key) => {
                                  return (
                                    <div key={key}>
                                      <>
                                        <>
                                          {' '}
                                          Question {key + 1} :{' '}
                                          <span
                                            style={{
                                              color: 'blue',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <b>Select</b>
                                          </span>
                                        </>
                                        <h4>
                                          <p
                                            className="abtcnt"
                                            // style={{ whiteSpace: 'pre-line' }}
                                            dangerouslySetInnerHTML={{
                                              __html: getValue(
                                                question,
                                                'text',
                                                ''
                                              ),
                                            }}
                                          />
                                        </h4>
                                        <div className="ml-3">
                                          <RenderAnswerPreview
                                            param={question.type}
                                            options={getValue(
                                              question,
                                              'options',
                                              []
                                            )}
                                            questions={question}
                                          />
                                        </div>
                                      </>
                                    </div>
                                  );
                                }
                              )
                            : 'Please wait...'}
                        </CardBody>
                      </Card>
                    </>
                  ) : (
                    'No Questions Found'
                  )}
                </Col>
              </Row>
            </div>
            {props.totalCount > 10 && (
              <Pagination
                activePage={props.pageNumber}
                itemsCountPerPage={props.limit}
                totalItemsCount={props.totalCount}
                pageRangeDisplayed={4}
                onChange={props.onProductPageChangeHandler}
                prevPageText="Prev"
                nextPageText="Next"
                hideFirstLastPages={true}
              />
            )}
          </TabPane>
        </TabContent>
      </div>
      <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalBody>
          <h3 className="text-center">Name your Survey</h3>
          <div className="form-group">
            <Label>
              Survey Name<span className="imp">*</span>
            </Label>
            <Input
              type="text"
              placeholder="Enter Survey Name"
              //   value={props.name}
              name="name"
              onChange={(e) => {
                // props.handleChange(e);
              }}
            />
          </div>
          <div className="btn-group-margin text-md-right">
            <Button
              color="blue"
              block
              // onClick={props.handleCreate}
            >
              Create Survey
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default QuestionBankHome;
